package pl.mothdigital.neuronowi.components.sections.footer

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.*
import org.jetbrains.compose.web.css.*
import pl.mothdigital.neuronowi.theme.*

val FooterDiverStyle = CssStyle {
    base {
        Modifier
            .width(100.percent)
            .height(1.px)
            .backgroundColor(SiteTheme.green._800.toRgb().copy(alpha = 200))
            .bottom(0.px)
    }
}

@Composable
fun FooterDiver() {
    Box(modifier = FooterDiverStyle.toModifier())
}
